export default {
    // Stores bible studies where user is leader
    bibleStudies: null,
    // Stores one bible study resource at a time
    bibleStudy: null,
    // {
    //     name: null,
    //     meeting_location: null,
    //     bible_study_leader: { name: null },
    //     bible_study_schedule: {
    //         day_of_week: null,
    //         meeting_time: null,
    //     },
    // },
    // Stores active bible study participants for one bible study at a time
    bibleStudyParticipants: null,
    // Stores all bible study participants for one bible study at a time
    allBibleStudyParticipants: null,
    // Stores bible study attendances for one bible study at a time
    bibleStudyAttendances: null,
    // Stores one bible study attendance at a time
    bibleStudyAttendance: null,
    // Stores people that are eligible to be added to a bible study for this user
    eligibleParticipants: null,
    // Stores people that are eligible for the user to switch a bible study to
    eligibleLeaders: null,
    cancelReasons: null,
    loading: false,
    error: ''
};
